// src/pages/performance/ManageAppraisalsStatusChip.jsx
import React from "react";
import { Chip } from "@mui/material";

export default function StatusChip({ value }) {
  const v = String(value || "").toLowerCase();

  const isSuccess = ["completed", "approved", "done", "locked"].includes(v);
  const isInfo = ["in_progress", "pending", "submitted", "in review", "in_review"].includes(v);
  const isWarn = ["skipped", "optional"].includes(v);
  const isErr = ["rejected", "returned", "failed"].includes(v);

  const color = isSuccess ? "success" : isErr ? "error" : isWarn ? "warning" : isInfo ? "info" : "default";

  const labelMap = {
    in_progress: "In progress",
    not_started: "Not started",
    in_review: "In review",
  };

  const label =
    labelMap[v] ||
    (value
      ? String(value)
          .replace(/_/g, " ")
          .replace(/\b\w/g, (m) => m.toUpperCase())
      : "—");

  return <Chip size="small" color={color} label={label} sx={{ fontWeight: 700 }} />;
}
